import isSameWeek from 'date-fns/isSameWeek';
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import parseISO from 'date-fns/parseISO';
import { useLocales } from 'src/locales';

export const formatDateDivider = (dateStr: string) => {
  const { currentLang, translate } = useLocales();
  const date = parseISO(dateStr);

  if (isToday(date)) {
    return translate('shared.buttons.today');
  }

  if (isYesterday(date)) {
    return translate('shared.buttons.yesterday');
  }

  if (isSameWeek(date, new Date())) {
    // return weekday
    return date.toLocaleString(currentLang.value, { weekday: 'long' });
  }

  // if (isSameMonth(date, new Date())) {
  //   // return month
  //   return date.toLocaleString('en-US', { month: 'long' });
  // }

  return date.toLocaleString(currentLang.value, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
